export function trackEvent(name: string, data?: Record<string, string | number>) {
  window.umami?.track(name, data)
}
